import { render, staticRenderFns } from "./CardArrow.vue?vue&type=template&id=3b5c41c4&"
import script from "./CardArrow.vue?vue&type=script&lang=js&"
export * from "./CardArrow.vue?vue&type=script&lang=js&"
import style0 from "./CardArrow.vue?vue&type=style&index=0&id=3b5c41c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports